/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import md5 from 'js-md5'
import { message } from 'ant-design-vue';
import router from '../router'
import store from '@/store'  // 导入store
import { generateBrowserUserId } from './util'
// import store from '../store'
// 跨域认证信息 header 名
const xsrfHeaderName = 'Authorization'
axios.defaults.timeout = 60000
axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = xsrfHeaderName
axios.defaults.xsrfCookieName = xsrfHeaderName
 
// post请求头
// axios.defaults.headers.post['Content-Type'] = '';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        
        let userId = store.state.user.userInfo ? store.state.user.userInfo.id : generateBrowserUserId()
        // console.log(store.state.user.userInfo)
        let token = localStorage.getItem('web_login_token')
        token && (config.headers[xsrfHeaderName] ='Bearer ' + token);
        config.headers['ts'] = +new Date();
        config.headers['requuid'] = md5(`${token}${config['url']}`);
        config.headers['CHANNEL-CODE'] = store.state.channel.channelCode || sessionStorage.getItem('weidun_channel_code');
        config.headers['USER-ID'] = userId

        return config;    
    },
    error => {
        return Promise.error(error);    
    })
// 响应拦截器
let whiteUrl = ['/doLogin','/doMobile','/oauth/wx','/audio-to-text','/text-to-audio','/agent/channel'] // 接口白名单
axios.interceptors.response.use(    
    response => {
        let { config:{ url } } = response
        let isWhiteUrl = false
        // console.log(response,'response')
        if (response.status === 200) {
            if(response.data.code == 40001){
                let redirect = window.location.href && window.location.href.split('#')[1]
                // 清除token
                localStorage.removeItem('web_login_token')
                if(redirect && redirect.indexOf('/login') == -1){
                  // 跳转登录页
                  router.replace('/login')
                    // if(state.channel.isLogin){
                    //     router.replace('/login')
                    // }
                }
            }
            if(response.data.code != 200){
                whiteUrl.map(item => {
                    if(url.indexOf(item) != -1){
                        isWhiteUrl = url.indexOf(item) != -1
                        return
                    }
                })
                if(!isWhiteUrl){
                    if(url.indexOf('/personal/center/supplement/evidence') != -1) response.data.message ='已补充，请勿重复提交。' ;
                    message.error(response.data.message);
                }
            }
            return Promise.resolve(response);        
        } else if(response.status == 403){
            let redirect = window.location.href && window.location.href.split('#')[1]
            // 清除token
            localStorage.removeItem('web_login_token')
            if(redirect && redirect.indexOf('/login') == -1){
                // 跳转登录页
                router.replace('/login')
                // if(state.channel.isLogin){
                //     router.replace('/login')
                // }
            }
        } else {            
            return Promise.reject(response);        
        }    
    },
    // 服务器状态码不是200的情况    
    error => {
        if(error.response){
            switch (error.response.status){
                case 500:
                    message.error(error.response.data.message);
                    break;
                case 403:
                    let redirect = window.location.href && window.location.href.split('#')[1]
                    // 清除token
                    localStorage.removeItem('web_login_token')
                    if(redirect && redirect.indexOf('/login') == -1){
                        // 跳转登录页
                        if(state.channel.isLogin){
                            router.replace('/login')
                        }
                    }
                    break;
                // case 404:
                //     message.error('服务不通');
                //     break;
            }
        }
        return Promise.error(error.response);    
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params  
        })        
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, data) {    
    return new Promise((resolve, reject) => {         
        axios.post(url, {
            ...data
        })        
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteRequstt(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data:params })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/** 
 * put方法，对应put请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function putUpload(url, data) {    
    return new Promise((resolve, reject) => {         
        axios.put(url, data,{
            headers:{
                'Content-Type':'multipart/form-data;'
            }
        })        
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function posttUpload(url, data, ContentType='multipart/form-data;') {
    return new Promise((resolve, reject) => {
        axios.post(url, data,{
            headers:{
                'Content-Type':ContentType
            }
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * postBinary方法 - 用于获取二进制数据（如音频、PDF等）
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求体参数]
 */
export function postBinary(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {
            responseType: 'arraybuffer', // 🔑 核心
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
}